<template>
  <v-container fluid class="webConActivity-management mt-4 px-1">
    <v-row>


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการประวัติอบรม/ร่วมโครงการ/รางวัลที่ได้รับ</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{
              '\xa0 (' + webConActivitys.length
            }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>

            </div>
          </v-card-title>

          <v-card-title class="pa-5 pb-0">
            <v-row align="center">


              <v-col class="d-flex" cols="12" sm="2">

                <v-select
                    @change="searchData"
                    v-model="search_data.activity_type"
                    :items="activity_type_combo"
                    item-text="parameter_th"
                    item-value="parameter_value"
                    label="ประเภท"
                    clearable

                ></v-select>


              </v-col>


              <v-col class="d-flex" cols="12" sm="2">

                <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        @change="clearableDate('start')"
                        v-model="dateFormatted3"
                        label="เริ่มต้น"
                        hint="วัน/เดือน/พ.ศ."
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      @change="searchData"
                      v-model="date3"
                      :first-day-of-week="1"
                      locale="th"
                      @input="menu3 = false"
                  ></v-date-picker>
                </v-menu>


              </v-col>


              <v-col class="d-flex" cols="12" sm="2">

                <v-menu
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        @change="clearableDate('end')"
                        v-model="dateFormatted4"
                        label="สิ้นสุด"
                        hint="วัน/เดือน/พ.ศ."
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      @change="searchData"
                      v-model="date4"
                      :first-day-of-week="1"
                      locale="th"
                      @input="menu4 = false"
                  ></v-date-picker>
                </v-menu>


              </v-col>


              <v-col class="d-flex" cols="12" sm="2">

                <v-select
                    @change="searchData"
                    v-model="search_data.status_check"
                    :items="status_check_combo"
                    item-text="v_name"
                    item-value="v_value"
                    label="สถานะ"
                    clearable=""
                ></v-select>


              </v-col>


              <v-col class="d-flex" cols="12" sm="2">

                <v-select
                    @change="searchData"
                    v-model="search_data.user_name"
                    :items="activity_users_combo"
                    item-text="full_name_th"
                    item-value="user_name"
                    label="บุคลากร"
                    clearable=""

                ></v-select>


              </v-col>


              <v-col class="d-flex" cols="12" sm="2">
                <v-text-field
                    append-icon="mdi-magnify"
                    class="search"
                    v-model="search"
                    label="ค้นหา (Search)"
                ></v-text-field>
              </v-col>


            </v-row>

          </v-card-title>


          <v-card>


          </v-card>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items="webConActivitys"
                :search="search"
                sort-by="activity_id">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>


                  <v-btn style="margin-left: 10px;"
                         color="blue-grey"
                         class="ma-2 white--text"
                         @click="downloadReport('xlsx')"
                  >ดาวน์โหลด Excel
                    <v-icon
                        right
                        dark
                    >
                      mdi-file-excel
                    </v-icon>
                  </v-btn>

                  <v-btn style="margin-left: 10px;"
                         color="blue-grey"
                         class="ma-2 white--text"
                         @click="downloadReport('pdf')"
                  >พิมพ์ข้อมูล
                    <v-icon
                        right
                        dark
                    >
                      mdi-printer
                    </v-icon>
                  </v-btn>


                </template>


              </template>


              <template v-slot:item.activity_type="{ item }">
                <span>{{ displayText(item.activity_type) }}</span>

              </template>

              <template v-slot:item.activity_title_th="{ item }">
                <span>{{ item.activity_title_th }}</span>
                <sup>{{ item.activity_agency_title }}</sup><br>
                <span>║ {{ item.activity_place_title }}</span>

              </template>


              <template v-slot:item.activity_date="{ item }">
                <span> {{ dataFormatter.dateFormatterTH(item.activity_date, 3) }}</span>


              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>

              <template v-slot:item.status_check="{ item }">
                <span v-if="item.status_check == 'W'" class="v-chip theme--light v-size--small warning"><span
                    class="v-chip__content">{{ displayStatusCheckText(item.status_check) }}</span></span>

                <span v-else-if="item.status_check == 'S'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">{{ displayStatusCheckText(item.status_check) }}</span></span>

                <span v-else-if="item.status_check == 'C'" class="v-chip theme--light v-size--small secondary"><span
                    class="v-chip__content">{{ displayStatusCheckText(item.status_check) }}</span></span>

                <span v-else-if="item.status_check == 'E'" class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">{{ displayStatusCheckText(item.status_check) }}</span></span>


              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }} : </p>

            <span>  {{
                currentUser.user_name
              }}</span>


          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      v-model="editForm.activity_type"
                      :rules="editForm.textReqRules"
                      :items="activity_type_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ประเภท"
                      clearable=""
                      required
                  ></v-select>

                </v-col>

                <v-col class="d-flex" cols="12" sm="2">


                  <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="dateFormatted"
                          :rules="editForm.textReqRules"
                          label="วันที่กิจกรรม"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        :rules="editForm.textReqRules"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>


                <v-col class="d-flex" cols="12" sm="6">
                  <v-radio-group row v-model="editForm.activity_level">

                    <v-radio value="L1">
                      <template v-slot:label>
                        <div>ระดับ <strong class="success--text">นานาชาติ</strong></div>
                      </template>
                    </v-radio>
                    <v-radio value="L2">
                      <template v-slot:label>
                        <div>ระดับ <strong class="primary--text">ประเทศ</strong></div>
                      </template>
                    </v-radio>

                    <v-radio value="L3">
                      <template v-slot:label>
                        <div>ระดับ <strong class="primary--text">จังหวัด/มหาวิทยาลัย</strong></div>
                      </template>
                    </v-radio>

                    <v-radio value="L4">
                      <template v-slot:label>
                        <div>ระดับ <strong class="primary--text">คณะ</strong></div>
                      </template>
                    </v-radio>

                  </v-radio-group>
                </v-col>


              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">

                  <v-textarea
                      rows="2"
                      v-model="editForm.activity_title_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อโครงการ/รางวัล (TH)"
                      required
                  ></v-textarea>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-textarea
                      rows="2"
                      v-model="editForm.activity_title_en"
                      :rules="editForm.textReqRules"
                      label="ชื่อโครงการ/รางวัล (EN)"
                      required
                  ></v-textarea>

                </v-col>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">

                  <v-textarea
                      rows="2"
                      v-model="editForm.activity_agency_title"
                      :rules="editForm.textReqRules"
                      label="หน่วยงานผู้จัด"
                      required
                  ></v-textarea>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-textarea
                      rows="2"
                      v-model="editForm.activity_place_title"
                      :rules="editForm.textReqRules"
                      label="สถานที่"
                      required
                  ></v-textarea>

                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-textarea
                      rows="2"
                      v-model="editForm.remark"
                      label="หมายเหตุ"

                  ></v-textarea>

                </v-col>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.status_link"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="อัพโหลดไฟล์ | URL"
                      required
                  ></v-switch>

                </v-col>

                <v-col class="d-flex" cols="12" sm="10" v-if="state=='addForm'">
                  <v-file-input
                      v-if="editForm.status_link=='Y'"
                      v-model="editForm.avatarFileFi"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.fileRules)"
                      placeholder="อัพโหลดไฟล์"
                      prepend-icon="mdi-file"
                      label="อัพโหลดไฟล์"
                  ></v-file-input>

                  <v-text-field
                      v-if="editForm.status_link=='N'"
                      v-model="editForm.activity_h_url"
                      :rules="editForm.textReqRules"
                      label="URL ของไฟล์"
                      required
                  ></v-text-field>

                </v-col>
                <v-col class="d-flex" cols="12" sm="10" v-if="state=='editForm'">


                  <div class="text-center" v-if="editForm.status_link=='Y' && !editForm.avatarFileFiOld==false">
                    <v-chip
                        link
                        class="ma-4"
                        color="default"
                    >
                      <v-icon left>mdi-file</v-icon>
                      <a :href="baseURLStorage+editForm.avatarFileFiOld" target="_blank">
                        ไฟล์อัพโหลดเดิม </a>
                    </v-chip>
                  </div>


                  <v-file-input
                      v-if="editForm.status_link=='Y'"
                      v-model="editForm.avatarFileFi"
                      show-size
                      chips
                      :rules="editForm.fileRules"
                      placeholder="อัพโหลดไฟล์ใหม่"
                      prepend-icon="mdi-file"
                      label="อัพโหลดไฟล์ใหม่"
                  ></v-file-input>


                  <v-text-field
                      v-if="editForm.status_link=='N'"
                      v-model="editForm.activity_h_url"
                      :rules="editForm.textReqRules"
                      label="URL ของไฟล์"
                      required
                  ></v-text-field>

                </v-col>


              </v-row>


              <v-row v-if="this.editForm.activity_type=='A1'">

                <div class="v-card__title pa-5 pb-3"><p>นำรายชื่อเข้าสู่ระบบ : </p>
                  <span class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + checkboxModel.length }} รายการ) </span>
                </div>

                <v-spacer></v-spacer>
                <v-btn style="margin-left: 10px;"
                       color="primary"
                       class="ma-2 white--text"
                       @click="selectAll"
                >ทั้งหมด
                  <v-icon
                      right
                      dark
                  >
                    mdi-select-all
                  </v-icon>
                </v-btn>

                <v-btn style="margin-left: 10px;"
                       color="blue-grey"
                       class="ma-2 white--text"
                       @click="deselectAll"
                >ล้าง
                  <v-icon
                      right
                      dark
                  >
                    mdi-select-remove
                  </v-icon>
                </v-btn>


                <v-row>
                  <v-col cols="12" sm="4" md="3" v-for="(item, index) in activity_users_combo_all" :key="index">
                    <v-checkbox
                        v-model="checkboxModel"
                        :key="item.user_name"
                        :value="item.user_name"
                    >
                      <template v-slot:label>
                        <v-avatar>
                          <img
                              :src="baseURLStorage+item.avatarFile"
                              :alt="item.full_name_th"
                          >
                        </v-avatar>

                        <strong> &nbsp; &nbsp; {{ item.full_name_th }} </strong>
                      </template>

                    </v-checkbox>
                  </v-col>
                </v-row>


              </v-row>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>

                </v-col>

                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.green_office"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="สำนักงานสีเขียว"
                      required
                  ></v-switch>

                </v-col>

              </v-row>

              <v-row align="center" v-if="activity_users_combo.length>1">
                <v-chip
                    color="secondary"
                    class="ma-2"
                >
                  สำหรับเจ้าหน้าที่/ผู้ดูแลระบบ
                </v-chip>


                <v-col class="d-flex" cols="12" sm="3">

                  <v-select
                      v-model="editForm.status_check"
                      :rules="editForm.textReqRules"
                      :items="status_check_combo"
                      item-text="v_name"
                      item-value="v_value"
                      label="สถานะเอกสาร"
                      clearable=""
                      required
                  ></v-select>

                </v-col>
              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>


        <!--        <v-row>
                  <p>นำรายชื่อเข้าสู่ระบบ</p>
                  <span class="grey&#45;&#45;text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + checkboxModel.length }} รายการ) </span>
                  <v-spacer></v-spacer>

                  <v-btn style="margin-left: 10px;"
                         color="primary"
                         class="ma-2 white&#45;&#45;text"
                         @click="selectAll"
                  >ทั้งหมด
                    <v-icon
                        right
                        dark
                    >
                      mdi-select-all
                    </v-icon>
                  </v-btn>

                  <v-btn style="margin-left: 10px;"
                         color="blue-grey"
                         class="ma-2 white&#45;&#45;text"
                         @click="deselectAll"
                  >ล้าง
                    <v-icon
                        right
                        dark
                    >
                      mdi-select-remove
                    </v-icon>
                  </v-btn>

                  <v-row>

                    <template v-for="item in activity_users_combo_all">
                      <v-col cols="12" sm="4" md="3" :key="item">
                        <v-checkbox
                            v-model="checkboxModel"
                            :key="item.user_name"
                            :value="item.user_name"
                            hide-details
                        >
                          <template v-slot:label>
                            <v-avatar>
                              <img
                                  :src="baseURLStorage+item.avatarFile"
                                  :alt="item.full_name_th"
                              >
                            </v-avatar>

                            <strong> &nbsp; &nbsp;  {{item.full_name_th}} </strong>
                          </template>
                        </v-checkbox>
                      </v-col>
                    </template>
                  </v-row>

                </v-row>-->


      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapMutations, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
// import Editor from '@tinymce/tinymce-vue';
// import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';
import axios from "axios";
import dataFormatter from "@/use/dataFormatter";

export default {
  name: 'ConActivityManagement',
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      modal: false,
      menu2: false,

      date3: '',
      date4: '',
      dateFormatted3: '',
      dateFormatted4: '',
      // date3: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // date4: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // dateFormatted3: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      // dateFormatted4: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),

      menu3: false,
      menu4: false,

      datemonth: (new Date().toISOString().substr(0, 7)),
      datemonthFormatted: this.formatDateMonth((new Date().toISOString().substr(0, 7))),

      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      dialog_upload: false,
      search: '',
      search_data: {
        activity_type: "",
        status_check: "",
        user_name: "",
        start_date: '',
        end_date: '',

      },
      selected: [],
      headers: [
        {
          text: 'ประเภท',
          align: 'start',
          value: 'activity_type',
          width: '15%'
        },
        {text: 'อบรม/โครงการ/รางวัล', value: 'activity_title_th', width: '45%'},
        {text: 'วันที่กิจกรรม', value: 'activity_date', width: '10%'},
        {text: 'ใช้งาน', value: 'active', width: '5%'},
        {text: 'สถานะ', value: 'status_check', width: '5%'},
        {text: 'การจัดการ', value: 'api', sortable: false, width: '15%'},
      ],
      status_check_combo: [
        {v_value: 'W', v_name: 'อยู่ระหว่างตรวจสอบ'},
        {v_value: 'S', v_name: 'ข้อมูลถูกต้อง'},
        {v_value: 'C', v_name: 'ข้อมูลไม่ถูกต้อง'},
        {v_value: 'E', v_name: 'ยกเลิก'},
      ],
      activity_type_combo: [],
      activity_users_combo: [],
      activity_users_combo_all: [],
      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {},
      checkboxModel: [], // [] * {} ไม่เหมือนกันระวังการใช้ รวมกับ multiselect

    }
  },
  components: {
    // 'editor': Editor, // <- Important part
    // UploadManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_activitys', ['webConActivitys', "isReceiving", "isDeleting", "idToDelete", "webConActivityMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
    dataFormatter() {
      return dataFormatter;
    },

    //Date Picker Format
    computedDateFormatted() {
      return this.formatDate(this.date)
    },

    //Date Picker Format
    computedDateFormatted3() {
      return this.formatDate(this.date3)
    },

    //Date Picker Format
    computedDateFormatted4() {
      return this.formatDate(this.date4)
    },

    computedDateMonthFormatted() {
      return this.formatDateMonth(this.datemonth)
    },
    //getDataUserLogin

    ...mapState('auth', {
      currentUser: (state) => state.currentUser,
    }),
    ...mapState({
      data: (state) => state.usersForm.data,
    }),
  },
  async beforeMount() {

    //getDataUserLogin //cannot remember write for use
    /*    try {

          const { user } = JSON.parse(localStorage.getItem('user'));
          const id = user.id;

          if (id) {
            this.id = id;
            await this.getData(id);
            this.formatData();
          }
        } catch (e) {
          this.showSnackbar(e);
        }*/
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConActivityMessage() {

      if (this.webConActivityMessage !== '') {
        this.notification = this.webConActivityMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {

          this.addSuccessNotification();

        }
        this.close();
      }
    },

    //Date Picker Format
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
    date3() {
      this.dateFormatted3 = this.formatDate(this.date3)
    },
    date4() {
      this.dateFormatted4 = this.formatDate(this.date4)
    },
    datemonth() {
      this.datemonthFormatted = this.formatDateMonth(this.datemonth)
    },
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWebConActivitysRequest(this.search_data);
    this.getDcParamCombobox();
    this.resetValue();
  },
  methods: {

    //getDataUserLogin
    ...mapMutations({
      showSnackbar: 'snackbar/showSnackbar',
    }),
    ...mapActions({
      getData: 'usersForm/getData',
    }),

    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_activitys',
        [
          "getWebConActivitysRequest",
          "deleteWebConActivityRequest",
          "updateWebConActivityRequest",
          "createWebConActivityRequest"
        ]
    ),
    formatData() {
      // this.fname_th = this.data.fname_th;
      // this.lname_th = this.data.lname_th;
      // this.user_platform_reg = this.data.user_platform_reg;
      // this.email = this.data.email;
      // this.role = this.data.role;
      // this.avatar = this.data.avatar;
    },
    resetValue() {


      this.editForm = {}
      this.editForm = {
        valid: true,
        numRules: validateRules.numRules,
        textReqRules: validateRules.textReqRules,
        imageRules: validateRules.fileSingleRules(3),
        fileRules: validateRules.fileSingleRules(100),
        activity_id: null,
        activity_type: '',
        activity_level: 'L4',
        status_link: 'Y',
        activity_h_url: '#',
        active: 'Y',
        green_office: 'Y',
        status_check: 'W',
        avatarFileFi: null,
        avatarFileFiOld: null,

      }
      this.checkboxModel = []


    },
    async getActivityUser(activity_id) {
      try {
        const formData = new FormData();
        formData.append('activity_id', activity_id);
        await axios.post(config.baseURLApi + '/get_web_con_activitys_user', formData, {
          headers: {},
        }).then(res => {

          const users = res.data;
          const convertedUsers = users.map(user => {
            return user.user_name;
          });
          this.checkboxModel = convertedUsers;

          return convertedUsers;


        });


      } catch (e) {
        this.showSnackbar(e);
      }

    },
    async getDcParamCombobox() {

      try {

        await axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'ACTIVITYS_TYPE', '', {
          headers: {},
        }).then(res => {
          this.activity_type_combo = res.data;
        });


        const formData = new FormData();
        formData.append('role_group', 'web1');
        formData.append('role_page', '/web/content_activity');
        formData.append('check_role', '');

        await axios.post(config.baseURLApi + '/combo/' + 'usersActiveOwn', formData, {
          headers: {},
        }).then(res => {
          this.activity_users_combo = res.data;
        });

        await axios.post(config.baseURLApi + '/combo/' + 'usersActive', {
          headers: {},
        }).then(res => {
          this.activity_users_combo_all = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }


    },


    addItem() {
      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.active = 'Y';
      this.editForm.green_office = 'N';
      this.editForm.activity_type = 'A2';
      this.editForm.activity_level = 'L4'
      this.editForm.status_link = 'Y'
      this.editForm.status_check = 'W'
      this.editForm.activity_h_url = '#';
      this.editForm.remark = '-';
      this.state = 'addForm';


    },
    editItem(item) {
      this.resetValue();
      this.editedIndex = this.webConActivitys.indexOf(item) //index ของ row ที่จะแก้ไข

      this.date = item.activity_date;
      this.dateFormatted = this.formatDate(item.activity_date);

      this.getActivityUser(item.activity_id);
      this.editForm.activity_id = item.activity_id;
      this.editForm.activity_type = item.activity_type;
      this.editForm.activity_level = item.activity_level;
      this.editForm.activity_title_th = item.activity_title_th;
      this.editForm.activity_title_en = item.activity_title_en;
      this.editForm.activity_agency_title = item.activity_agency_title;
      this.editForm.activity_place_title = item.activity_place_title;
      this.editForm.remark = item.remark,
          this.editForm.activity_date = item.activity_date;
      this.editForm.status_link = item.status_link;
      this.editForm.activity_h_file = item.activity_h_file;
      this.editForm.avatarFileFiOld = item.activity_h_file;
      this.editForm.activity_h_url = item.activity_h_url;
      this.editForm.status_check = item.status_check;
      this.editForm.active = item.active;
      this.editForm.green_office = item.green_office;


      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConActivityRequest({activity_id: item.activity_id})

    },
    close() {

      if (this.errorMessage == false || this.webConActivityMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {

      this.editForm.activity_date = this.date;
      this.editForm.checkbox_select = this.checkboxModel;

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConActivitys[this.editedIndex], this.editForm)
            :
            this.updateWebConActivityRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConActivitys.push(this.editForm)
            :
            this.createWebConActivityRequest(this.editForm)
      }


    },
    downloadReport(extension) {

      // console.log(this.date3);
      // console.log(this.date4);
      // console.log(extension);
      var activity_type = this.search_data.activity_type;
      var start_date = this.date3;
      var end_date = this.date4;

      var username = (this.search_data.user_name == "" || this.search_data.user_name == null) ? this.currentUser.user_name : this.search_data.user_name;
      var url = config.baseURLApi + '/report/master_r_002?username=' + username + '&extension=' + extension + '&activity_type=' + activity_type + '&start_date=' + start_date + '&end_date=' + end_date
      window.open(url);
    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    async reset() {
      await this.$refs.form.reset()
      this.resetValue()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },

    //Date Picker Format

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${(year) * 1 + 543}`
    },
    formatDateMonth(date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${(year) * 1 + 543}`
    },

    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    parseDateMonth(date) {
      if (!date) return null
      const [month, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}`
    },
    searchData() {

      this.checkStartEnd();
      this.search_data.start_date = this.date3;
      this.search_data.end_date = this.date4;
      this.getWebConActivitysRequest(this.search_data);

      // console.log(this.search_data)
    },
    clearableDate(item) {
      if (item == 'start') {
        this.date3 = '';
      } else {
        this.date4 = '';
      }
      this.searchData();

    },
    checkStartEnd() {
      if (this.date3 != '' && this.date4 != '') {

        // แปลง string เป็น Date objects
        var startDateObject = new Date(this.date3);
        var endDateObject = new Date(this.date4);

        // เปรียบเทียบวันที่
        if (startDateObject > endDateObject) {
          alert("ข้อความเตือน: วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด")
          this.date3 = ''
          // console.log("ข้อความเตือน: start_date มากกว่า end_date");
        } else if (endDateObject < startDateObject) {
          alert("ข้อความเตือน: วันที่สิ้นสุด น้อยกว่า วันที่สิ้นสุด")
          this.date4 = ''
          // console.log("ข้อความเตือน: end_date น้อยกว่า start_date");
        }
      }
    },
    displayText(item) {
      return !this.activity_type_combo.length == true ? '' : (this.activity_type_combo.find(combobox => combobox.parameter_value === item)).parameter_th;

    },
    displayStatusCheckText(item) {
      return !this.status_check_combo.length == true ? '' : (this.status_check_combo.find(combobox => combobox.v_value === item)).v_name;

    },
    selectAll() {
      this.checkboxModel = this.activity_users_combo_all.map(item => item.user_name);
    },
    deselectAll() {
      this.checkboxModel = [];
    },

  },
}
</script>

<style src="./ConActivityManagement.scss" lang="scss"/>
